import { DefaultTimeline, DefaultTicker, Animate, ACustomAnimate, createRect, Generator } from "./../vrender";

import { isBoolean, isNumber } from "@visactor/vutils";

class Animateaaa extends ACustomAnimate {
    onUpdate(end, ratio, out) {
        if (this.from.x !== this.to.x) {
            const x = end ? this.to.x : this.from.x + Math.floor((this.to.x - this.from.x) * ratio);
            this.params.table.scrollLeft = x;
        }
        if (this.from.y !== this.to.y) {
            const y = end ? this.to.y : this.from.y + Math.floor((this.to.y - this.from.y) * ratio);
            this.params.table.scrollTop = y;
        }
    }
}

export class TableAnimationManager {
    constructor(table) {
        this.table = table, this.timeline = new DefaultTimeline, this.ticker = new DefaultTicker, 
        this.ticker.addTimeline(this.timeline);
        this.ticker.setFPS(60), this.tempGraphic = createRect({});
    }
    scrollTo(position, animationOption) {
        var _a, _b, _c, _d;
        const from = {
            x: this.table.scrollLeft,
            y: this.table.scrollTop
        }, cellRect = this.table.getCellRect(null !== (_a = position.col) && void 0 !== _a ? _a : 0, null !== (_b = position.row) && void 0 !== _b ? _b : 0), to = {
            x: isNumber(position.col) ? cellRect.left - this.table.getFrozenColsWidth() : this.table.scrollLeft,
            y: isNumber(position.row) ? cellRect.top - this.table.getFrozenRowsHeight() : this.table.scrollTop
        }, duration = isBoolean(animationOption) ? animationOption ? 3e3 : 0 : null !== (_c = null == animationOption ? void 0 : animationOption.duration) && void 0 !== _c ? _c : 3e3, easing = isBoolean(animationOption) ? animationOption ? "linear" : "" : null !== (_d = null == animationOption ? void 0 : animationOption.easing) && void 0 !== _d ? _d : "linear";
        new Animate(Generator.GenAutoIncrementId(), this.timeline).bind(this.tempGraphic).play(new Animateaaa(from, to, duration, easing, {
            graphic: this.tempGraphic,
            table: this.table
        }));
        this.ticker.start();
    }
    clear() {
        this.timeline.clear(), this.ticker.stop();
    }
}
//# sourceMappingURL=animation.js.map